import { TipoEntidadeFormulaEnum } from '@shared/enums/formula/tipo-entidade-formula.enum';
import { FormulaCicloDetectadoStruct } from '@shared/services/structs/formula/formula-ciclo-detectado.struct';

export class FormulaCicloDialogData {
    ciclo: FormulaCicloDetectadoStruct;
    titulo: string;
    /** Entidade em edição, quando a tela souber: os membros dela recebem "Esta natureza"/"Esta regra"/"Este DIFAL". */
    tipoEntidadeEdicao?: TipoEntidadeFormulaEnum | null;
    idEntidadeEdicao?: number | null;
}
